import { Grid } from '@mui/material';
import { Autocomplete } from '../../../../ui/components/pure/autocomplete/autocomplete.component';
import { FormControl } from '../../../../ui/components/pure/form-control/form-control.component';
import { TextField } from '../../../../ui/components/pure/text-field/text-field.component';
import { CourierFormModal } from '../../components/courier-form-modal.component';
import { fullWidthStyle, rowGroupStyle } from '../../components/courier-form.styles';
import { CompleteRegistrationActionProps, useCompleteRegistrationAction } from './complete-registration-action.hook';

/** Opened from the incomplete couriers list and from courier details. */
export function CompleteRegistrationModal(props: CompleteRegistrationActionProps) {
  const { state, handlers, control, handleSubmit, formConfig, unitMenuItems, loading, hierarchyError } =
    useCompleteRegistrationAction(props);

  return (
    <CourierFormModal
      title={`Complete registration${props.courier.mobile ? ` for ${props.courier.mobile}` : ''}`}
      loading={loading}
      saving={state.saving}
      error={state.error ?? hierarchyError ?? undefined}
      submitLabel="Complete registration"
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <Grid container spacing={2} style={rowGroupStyle}>
        <Grid size={12}>
          <Autocomplete
            control={control}
            name={formConfig.groupID.name}
            required={formConfig.groupID.required}
            label={formConfig.groupID.label}
            placeholder={formConfig.groupID.label}
            options={unitMenuItems}
            getOptionLabel={(option) => option.label}
            loading={loading}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={rowGroupStyle}>
        <Grid size={6}>
          <FormControl
            control={control}
            name={formConfig.firstName.name}
            required={formConfig.firstName.required}
            rules={{ validate: formConfig.firstName.validate }}
            Component={TextField}
            ComponentProps={{
              textFieldVariant: 'floating' as const,
              placeholder: formConfig.firstName.label,
              fullWidth: true,
              style: fullWidthStyle
            }}
          />
        </Grid>
        <Grid size={6}>
          <FormControl
            control={control}
            name={formConfig.lastName.name}
            required={formConfig.lastName.required}
            rules={{ validate: formConfig.lastName.validate }}
            Component={TextField}
            ComponentProps={{
              textFieldVariant: 'floating' as const,
              placeholder: formConfig.lastName.label,
              fullWidth: true,
              style: fullWidthStyle
            }}
          />
        </Grid>
      </Grid>
    </CourierFormModal>
  );
}
